import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubbles, messages, chat, communicate"} maskId="square-filled-radius-0-stroke-1-IconBubbles"><path fillRule="evenodd" clipRule="evenodd" d="M6.25195 3H22.002V15H18.002V19H10.6315L5.50195 21.8498V19H2.00195V7H6.25195V3ZM7.25195 7H18.002V14H21.002V4H7.25195V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbles;
